import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Handles hash scrolling and scroll-to-top that React Router v6 doesn't.
 *
 * - `#contact` → scroll to that element smoothly
 * - No hash, new path → scroll to top
 * - Same path, no hash (e.g. clicking "Inicio" while on home) → scroll to top
 */
export function ScrollManager() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 80);
      return () => {
        clearTimeout(timer);
      };
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    return undefined;
  }, [pathname, hash, key]);

  return null;
}
